<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M1.66602 15.9998C1.66602 8.08375 8.08326 1.6665 15.9993 1.6665C23.9154 1.6665 30.3327 8.08375 30.3327 15.9998C30.3327 23.9159 23.9154 30.3332 15.9993 30.3332C8.08326 30.3332 1.66602 23.9159 1.66602 15.9998ZM15.9993 3.6665C9.18783 3.6665 3.66602 9.18832 3.66602 15.9998C3.66602 22.8113 9.18784 28.3332 15.9993 28.3332C22.8108 28.3332 28.3327 22.8113 28.3327 15.9998C28.3327 9.18832 22.8108 3.6665 15.9993 3.6665ZM16.6817 9.25508C17.0922 9.62454 17.1254 10.2568 16.756 10.6673L16.7426 10.6822C16.3732 11.0927 15.7409 11.1259 15.3304 10.7565C14.9199 10.387 14.8866 9.75469 15.2561 9.34419L15.2694 9.32938C15.6389 8.91887 16.2712 8.88561 16.6817 9.25508ZM15.9993 14.3332C16.5516 14.3332 16.9993 14.7809 16.9993 15.3332V21.9998C16.9993 22.5521 16.5516 22.9998 15.9993 22.9998C15.4471 22.9998 14.9993 22.5521 14.9993 21.9998V15.3332C14.9993 14.7809 15.4471 14.3332 15.9993 14.3332Z"
			fill="#000"
		/>
	</svg>
</template>
